// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB_Lnj4FYBL8tAHxGxxneFeEw4h4Q-_I-8",
  authDomain: "closingchecklist-272ff.firebaseapp.com",
  databaseURL: "https://closingchecklist-272ff-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "closingchecklist-272ff",
  storageBucket: "closingchecklist-272ff.firebasestorage.app",
  messagingSenderId: "814152402711",
  appId: "1:814152402711:web:2ff4d9e75bc8bb5eed5952",
  measurementId: "G-VEDTKHC6G7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
